import { render } from "./BuscadorCredito.vue?vue&type=template&id=1ff1c016&scoped=true"
import script from "./BuscadorCredito.vue?vue&type=script&lang=js"
export * from "./BuscadorCredito.vue?vue&type=script&lang=js"

import "./BuscadorCredito.vue?vue&type=style&index=0&id=1ff1c016&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff1c016"]])

export default __exports__